/* unplugin-vue-components disabled */import { render } from "./article-card.vue?vue&type=template&id=19bdc820&scoped=true"
import script from "./article-card.vue?vue&type=script&lang=js"
export * from "./article-card.vue?vue&type=script&lang=js"

import "./article-card.vue?vue&type=style&index=0&id=19bdc820&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19bdc820"],['__file',"src/components/cards-v2/article-card.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "19bdc820"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('19bdc820', __exports__)) {
    api.reload('19bdc820', __exports__)
  }
  
  module.hot.accept("./article-card.vue?vue&type=template&id=19bdc820&scoped=true", () => {
    api.rerender('19bdc820', render)
  })

}


export default __exports__